import React, { FC, ReactNode } from 'react'

import { IconReload2, IconWarning } from '@avantstay/backoffice-vectors'

import * as S from './DataResultMessage.styles'

interface DataResultMessageProps {
  messageTitle: string
  message: string
  titleIcon?: ReactNode
  onTryAgain?: VoidFunction
}

export const DataResultMessage: FC<DataResultMessageProps> = ({
  titleIcon = <IconWarning />,
  messageTitle,
  message,
  onTryAgain,
}) => {
  return (
    <S.Container>
      <S.IconCircle>{titleIcon}</S.IconCircle>

      <S.MessageTitle>{messageTitle}</S.MessageTitle>

      <S.MessageWrapper>{message}</S.MessageWrapper>

      {onTryAgain ? (
        <S.ButtonFlat onClick={onTryAgain}>
          <IconReload2 />
          Try again
        </S.ButtonFlat>
      ) : null}
    </S.Container>
  )
}
